module.exports = __webpack_public_path__ + "static/moving_screenspace-8611e03a3a5bb78b9ca665e5402fd1e9.gif";